const emojiPickerGerman = {
    search: 'Suche',
        notfound: 'Kein Emoji gefunden',
        categories: {
        search: 'Emoji suchen',
            recent: 'Oft benutzt',
            people: 'Smileys & Personen',
            nature: 'Tiere & Natur',
            foods: 'Essen & Trinken',
            activity: 'Aktivität',
            places: 'Reisen & Orte',
            objects: 'Objekte',
            symbols: 'Symbole',
            flags: 'Flaggen',
            custom: 'Individuell',
    }
}

export {emojiPickerGerman};
